import { getMessageList } from "@/api/message-list";

const user = {
  state: {
    userInfo: {
      id: 1,
      name: ''
    },
    isComplete: 1,
    token: '',
    loginType: 0,//0是个人，1是省属单位，2非省属单位，  3是普通企业（不管）
    messageCount: 0,//未读消息数量
    userPhone: ''

  },
  getters: {
    userInfo(state) { //0就是个人信息不完善 1是完善了
      return state.userInfo
    },
    userPhone(state) {
      return state.userPhone
    },
    isComplete(state) { //
      return state.isComplete
    },
    loginType(state) { //
      return state.loginType
    },
    token(state) {
      // return state.token || localStorage.getItem('token');
      if (process.env.NODE_ENV === 'production') {
        return state.token
      } else {
        return localStorage.getItem('token');
      }
    },
    messageCount(state) {
      return state.messageCount;
    }
  },
  mutations: {
    setUserInfo(state, info) {
      state.userInfo = info
    },
    setComplete(state, info) {
      state.isComplete = info
    },
    setLoginType(state, info) {
      state.loginType = info
    },
    setToken(state, info) {
      if (process.env.NODE_ENV === 'production') {
        return state.token = info;
      } else {
        return localStorage.setItem('token', info);
      }
    },
    setMessageCount(state, count) {
      state.messageCount = count
    },
    setUserPhone(state, info) {
      state.userPhone = info
    }
  },
  actions: {
    updateUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo)
      commit('setComplete', userInfo?.is_complete || '')
      commit('setToken', userInfo?.token || '')
      commit('setLoginType', userInfo?.loginType || 0)
    },
    userPhone({ commit }, phone) {
      commit('setUserPhone', phone || '')
    },
    updateMessageCount({ commit, getters }, messageCount) {
      // let tk=user.getters.token(this)
      let tk = getters.token
      if (!tk) {//token 为空可可能是未登录或者退出登录，都不显示消息
        commit('setMessageCount', 0)
        return //未登录不获取消息
      }
      //无论如何更新未读消息
      getMessageList({
        pageNum: 1,
        pageSize: 0,
        isRead: 0
      }).then(result => {
        let count = result?.count || messageCount || 0;
        commit('setMessageCount', count)
      })
    },
  }
}

export default user